import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

const GET_BRAND_BY_NAME = gql`
    query getBrandByNameResponse($name: String!) {
        getBrandByNameResponse(name: $name) {
            code
            brand {
                id
                name
                name_kr
                description
                resizedSmallLogo
                resizedBigLogo
                follow_count
                product_count
            }
        }
    }
`;

const GET_SIMILAR_BRAND_QUERY = gql`
    query getSimilarBrands($brand_id: Int!) {
        getSimilarBrands(brand_id: $brand_id) {
            id
            name
            name_kr
            resizedSmallLogo
            follow_count
        }
    }
`;

export function useBrandWithSimilar(brandName) {
    // 첫 번째 쿼리: 브랜드 정보 가져오기
    const {
        loading: brandLoading,
        error: brandError,
        data: brandData
    } = useQuery(GET_BRAND_BY_NAME, {
        variables: { name: brandName },
        skip: !brandName
    });

    // 브랜드 ID 추출 (옵셔널 체이닝 없이)
    let brandId = null;
    if (brandData &&
        brandData.getBrandByNameResponse &&
        brandData.getBrandByNameResponse.brand) {
        brandId = brandData.getBrandByNameResponse.brand.id;
    }

    // 두 번째 쿼리: 관련 브랜드 가져오기
    const {
        data: similarData,
        loading: similarLoading,
        error: similarError
    } = useQuery(GET_SIMILAR_BRAND_QUERY, {
        variables: { brand_id: brandId ? Number(brandId) : 0 },
        skip: !brandId
    });

    // 결과 정리
    const brand = brandData &&
    brandData.getBrandByNameResponse &&
    brandData.getBrandByNameResponse.brand
        ? brandData.getBrandByNameResponse.brand
        : null;

    const similarBrands = similarData && similarData.getSimilarBrands
        ? similarData.getSimilarBrands
        : [];

    return {
        brand,
        similarBrands,
        loading: brandLoading || similarLoading,
        error: brandError || similarError
    };
}